import { Input, Select, SelectItem, Autocomplete, AutocompleteItem, DateRangePicker } from "@heroui/react";
import { FilterCard } from "@/components/data-table";
import { parseDate } from "@internationalized/date";

/**
 * Filter component for Purchase Order page
 *
 * @param {Object} filterOptions - Options for select filters (passed from parent)
 *   - suppliers: Array of { value, title }
 *   - statuses: Array of { value, title }
 *   - paymentMethods: Array of { value, title }
 */
const FilterData = ({ table, initialFilters, filterOptions = {} }) => {
    const { filterPanel } = table;
    const { isOpen, pending, setPending, apply, clear } = filterPanel;

    const {
        suppliers = [],
        statuses = [],
        paymentMethods = [],
    } = filterOptions;

    // Handle clear - reset to initial values
    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    // Derive dateRange from pending
    const dateRange =
        pending.date_from && pending.date_to
            ? {
                  start: parseDate(pending.date_from),
                  end: parseDate(pending.date_to),
              }
            : null;

    // Handle date range change
    const handleDateRangeChange = (range) => {
        if (range) {
            setPending((prev) => ({
                ...prev,
                date_from: range.start.toString(),
                date_to: range.end.toString(),
            }));
        } else {
            setPending((prev) => ({
                ...prev,
                date_from: "",
                date_to: "",
            }));
        }
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            {/* No. Order */}
            <Input
                label="No. Order"
                placeholder="Cari nomor order..."
                value={pending.order_number || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        order_number: val,
                    }))
                }
                variant="flat"
                isClearable
            />

            {/* Supplier */}
            <Autocomplete
                label="Supplier"
                placeholder="Pilih supplier"
                selectedKey={pending.supplier_id ? String(pending.supplier_id) : null}
                onSelectionChange={(key) =>
                    setPending((prev) => ({
                        ...prev,
                        supplier_id: key || "",
                    }))
                }
                variant="flat"
                isClearable
            >
                {suppliers.map((s) => (
                    <AutocompleteItem key={String(s.value)} value={s.value}>
                        {s.title}
                    </AutocompleteItem>
                ))}
            </Autocomplete>

            {/* Status */}
            <Select
                label="Status"
                placeholder="Pilih status"
                selectionMode="multiple"
                selectedKeys={
                    new Set(
                        Array.isArray(pending.status_id)
                            ? pending.status_id.map(String)
                            : [],
                    )
                }
                onSelectionChange={(keys) =>
                    setPending((prev) => ({
                        ...prev,
                        status_id: Array.from(keys),
                    }))
                }
                variant="flat"
            >
                {statuses.map((s) => (
                    <SelectItem key={String(s.value)} value={s.value}>
                        {s.title}
                    </SelectItem>
                ))}
            </Select>

            {/* Metode Bayar */}
            <Select
                label="Metode Bayar"
                placeholder="Pilih metode"
                selectionMode="multiple"
                selectedKeys={
                    new Set(
                        Array.isArray(pending.payment_method_id)
                            ? pending.payment_method_id.map(String)
                            : [],
                    )
                }
                onSelectionChange={(keys) =>
                    setPending((prev) => ({
                        ...prev,
                        payment_method_id: Array.from(keys),
                    }))
                }
                variant="flat"
            >
                {paymentMethods.map((p) => (
                    <SelectItem key={String(p.value)} value={p.value}>
                        {p.title}
                    </SelectItem>
                ))}
            </Select>

            {/* Rentang Tanggal */}
            <DateRangePicker
                label="Rentang Tanggal"
                value={dateRange}
                onChange={handleDateRangeChange}
                variant="flat"
            />
        </FilterCard>
    );
};

export default FilterData;
